module.exports = __webpack_public_path__ + "media/images/payment/edit-icon-49abfb0e25b13e3bd0eeda3ff2e1e948.svg";